import { setAlert } from "./ui";
import request from "../config";

const initialState = {
  isGenerating: false,
  token: undefined,
  isResetting: false
};

const GENERATE_API_TOKEN = "GENERATE_API_TOKEN";
const GENERATE_API_TOKEN_FAILED = "GENERATE_API_TOKEN_FAILED";
const GENERATE_API_TOKEN_SUCCESSFUL = "GENERATE_API_TOKEN_SUCCESSFUL";
const DESTROY_API_TOKEN = "DESTROY_API_TOKEN";
const DESTROY_API_TOKEN_FAILED = "DESTROY_API_TOKEN_FAILED";
const DESTROY_API_TOKEN_SUCCESSFUL = "DESTROY_API_TOKEN_SUCCESSFUL";

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case DESTROY_API_TOKEN:
      return {
        ...state,
        isResetting: true
      };

    case GENERATE_API_TOKEN:
      return {
        ...state,
        isGenerating: true
      };

    case DESTROY_API_TOKEN_FAILED:
    case GENERATE_API_TOKEN_FAILED:
      return {
        ...state,
        isGenerating: false,
        isResetting: false
      };

    case DESTROY_API_TOKEN_SUCCESSFUL:
      return {
        ...state,
        isGenerating: false,
        isResetting: false,
        token: action.token,
        resetted: true
      };

    case GENERATE_API_TOKEN_SUCCESSFUL:
      return {
        ...state,
        isGenerating: false,
        isResetting: false,
        token: action.token,
        resetted: false
      };

    default:
      return state;
  }
}

function generateSecretSuccessful(token) {
  return {
    type: GENERATE_API_TOKEN_SUCCESSFUL,
    token
  };
}

function destroySecretSuccessful(token) {
  return {
    type: DESTROY_API_TOKEN_SUCCESSFUL,
    token
  };
}

function generateSecretFailed() {
  return {
    type: GENERATE_API_TOKEN_FAILED
  };
}

function showIsGenerating() {
  return {
    type: GENERATE_API_TOKEN
  };
}

function showIsDestroing() {
  return {
    type: DESTROY_API_TOKEN
  };
}

export function generateApiToken(userCode) {
  return function(dispatch) {
    const config = {
      method: "POST",
      url: `/users/${userCode}/token`
    };

    dispatch(showIsGenerating());

    return request(config).then(resp => {
      const token = resp.data.api_token;
      dispatch(generateSecretSuccessful(token));
      dispatch(setAlert("New Api Token Generated"));
    });
  };
}

export function destroyApiToken(userCode) {
  return function(dispatch) {
    const config = {
      method: "DELETE",
      url: `/users/${userCode}/token`
    };

    dispatch(showIsDestroing());

    return request(config).then(resp => {
      const token = null;
      dispatch(destroySecretSuccessful(token));
      // dispatch(setAlert('New Api Token Generated'))
    });
  };
}
